import { Injectable } from '@angular/core';
import { ModalRoutingService } from '@woolworthsnz/styleguide';
import { MODAL_ROUTES } from '../constants';

@Injectable({
	providedIn: 'root',
})
export class CancelChangeOrderService {
	message = "Our team are picking your order, so we can't make any changes.";
	closeUrl: string | undefined;

	constructor(private modalRoutingService: ModalRoutingService) {}

	get cancelChangeOrderMessage(): string {
		return this.message;
	}

	get cancelChangeOrderCloseUrl(): string | undefined {
		return this.closeUrl;
	}

	displayCancelOrderModal(options?: { message?: string | undefined; closeUrl?: string | undefined }): void {
		if (options?.message) {
			this.message = options.message;
		}
		if (options?.closeUrl) {
			this.closeUrl = options.closeUrl;
		}

		this.modalRoutingService.open(MODAL_ROUTES.MODAL_OUTLET, MODAL_ROUTES.CANCEL_CHANGE_ORDER_PATH);
	}
}
